var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.custom_home_invadobay_slug && _vm.is_authenticated())?_c('invadobay-view',{attrs:{"slug":_vm.custom_home_invadobay_slug,"is_custom_home":true}}):_c('homepage',{on:{"search":_vm.reset_search_state}},[(_vm.is_authenticated())?_c('invadobays'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }